// context/NavbarContext.js
import React, { createContext, useState } from "react";

export const NavbarContext = createContext(null);

export const NavbarProvider = ({ children }) => {
	const [isTransparent, setIsTransparent] = useState(true);

	const value = {
		isTransparent,
		setIsTransparent,
	};

	return (
		<NavbarContext.Provider value={value}>{children}</NavbarContext.Provider>
	);
};
